import React, { useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import Context from 'Components/context';
import { language } from 'Root/constants';
import MakeupCategory from './MakeupCategory';
import ShadesList from './ShadesList';

import './CustomMakeups.scss';

const CustomMakeups = ({ handleShadeChange, resetSelectedMakeup }) => {
  const context = useContext(Context);
  const { makeupCleared, clearState, lensCleared } = context;

  useEffect(() => {
    lensCleared && resetSelectedMakeup();
    makeupCleared && clearState('selectedShadesSet'); // selectedShadesSet state get clear
  }, [makeupCleared, lensCleared]);

  return (
    <MakeupCategory appLang={language}>
      {(shades, type) =>
        !lensCleared &&
        !makeupCleared && (
          <ShadesList
            shades={shades}
            type={type}
            handleShadeChange={handleShadeChange}
          />
        )
      }
    </MakeupCategory>
  );
};

CustomMakeups.propTypes = {
  handleShadeChange: PropTypes.func.isRequired,
  resetSelectedMakeup: PropTypes.func.isRequired,
};

export default CustomMakeups;
